export default "__VITE_ASSET__D76vL6RF__"